import { render, staticRenderFns } from "./BCXDatePicker.vue?vue&type=template&id=b23174ca"
import script from "./BCXDatePicker.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXDatePicker.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BCXDatePicker.vue?vue&type=style&index=0&id=b23174ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports